import axios from 'axios'
import qs from 'qs'
import API from './ApiClass'
import { serverUrl } from '../common/helper/serverUrl'

const api = new API({ url: serverUrl('/api') })

api.createEntity({
  name: 'currentUser',
  endpoints: {
    get: axiosConfig => axios.get(`${api.url}/current-user`, axiosConfig),
  },
})

api.createEntity({
  name: 'auth',
  endpoints: {
    keepalive: axiosConfig => axios.get(`${api.url}/keepalive`, axiosConfig),
    login: (toPost, axiosConfig = {}) =>
      axios.post(`${api.url}/login`, qs.stringify(toPost), {
        ...axiosConfig,
        headers: { Accept: 'application/ld+json' },
      }),
    logout: axiosConfig => axios.get(`${api.url}/logout`, axiosConfig),
  },
})

export default api
